import { Injectable } from '@angular/core';
import { Field, FieldsRBush } from 'shared';
import DataSource from 'devextreme/data/data_source';
import { FieldService } from '../stores/field.service';
import { keyBy, find } from 'lodash';
import { booleanOverlap, simplify } from '@turf/turf';
import { area, intersect } from '@turf/turf';
import * as jsts from 'jsts';

@Injectable({
  providedIn: 'root'
})
export class FieldIndexService {

  private fields: { [id: number]: Field };
  private readonly fieldsDs: DataSource;
  private readonly index: FieldsRBush;
  private readonly reader = new jsts.io.GeoJSONReader();

  constructor(
    private fieldService: FieldService
  ) {

    // Index
    this.index = new FieldsRBush();

    // Fields DataSource
    this.fieldsDs = fieldService.newDataSource({
      paginate: false,

    });

  }

  async load() {
    const fieldsList = await this.fieldsDs.load();

    // Create lists
    this.fields = keyBy(fieldsList, 'id');

    // Reload the index
    this.index.clear();
    this.index.load(fieldsList);
  }

  update(field: Field) {
    if (field.id) {
      this.index.remove(field);
    }
    this.index.insert(field);
  }

  remove(field: Field) {
    if (!field.id) {
      return;
    }
    this.index.remove(field);
    delete this.fields[field.id];
  }

  checkOverlaps(field: Field, tolerance = 0) {
    const s = this.index.search(field.bbox);

    return find(s, (item) => {
      if (item.id === field.id) {
        return false;
      }

      if (!booleanOverlap(item.geojson, field.geojson)) {
        return false;
      }

      if (tolerance === 0) {
        return true;
      }

      let inter = intersect(item.geojson, field.geojson);
      if (!inter) {
        return false;
      }

      inter = simplify(inter, { tolerance: 2, highQuality: false, mutate: true });
      if (!inter) {
        return false;
      }

      return area(inter) > tolerance;
    });
  }
}
